export const APP_INIT = 'app:init'

export const ANNOTATION_CREATE_FUNCTION_CALL = 'annotation:create:function-call'

export const JUMP_TO_FRAME_TIMELINE_FRAME_CLICK = 'jump-to-frame:timeline-frame:click'
export const SYNC_VIDEO_PLAYBACK_CALL = 'sync-video-playback:call'

export const FIRST_ANNOTATION_RENDERED = 'first:annotation:rendered'
export const ACTIVE_ANNOTATION_RENDERED = 'active:annotation:rendered'
export const RENDER_IMAGE_AND_ANNOTATIONS = 'render:image-and-annotations'
export const RENDERED_CALL = 'render:call'

export const OVERLAYS_HTML_SUB_ANNOTATION_RENDERED = 'overlays:html:sub-annotation:rendered'

export const ALL_OVERLAYS_RENDERED = 'overlays:all:rendered'

export const LAYER_BAR_ITEM_MOUNTED = 'layer-bar:item:mounted'

export const GET_RESPONSE_WITH_ANNOTATIONS = 'get-response:with-annotations'

export const PAGINATION_REQUEST_ANNOTATION_FRAME_DATA = 'pagination:request:annotation-frame-data'
export const PAGINATION_GET_RESPONSE_WITH_ANNOTATION_FRAME_DATA =
  'pagination:get-response:with-annotation-frame-data'
export const PAGINATION_GET_RESPONSE_WITH_ANNOTATION_METADATA =
  'pagination:get-response:with-annotation-metadata'

export const RENDER_MASKS_START = 'render:masks:start'
export const RENDER_MASKS_END = 'render:masks:end'

export const RASTER_RENDER_START = 'raster:render:start'
export const RASTER_RENDER_END = 'raster:render:end'

export const RASTER_INVALIDATE_START = 'raster:invalidate:start'
export const RASTER_INVALIDATE_END = 'raster:invalidate:end'

export const RASTER_DELETE_LABEL_FROM_RASTER_START = 'raster:delete-label-from-raster:start'
export const RASTER_DELETE_LABEL_FROM_RASTER_END = 'raster:delete-label-from-raster:end'

export const MASK_BRUSH_START = 'mask:brush:start'
export const MASK_BRUSH_END = 'mask:brush:end'
export const MASK_BRUSH_MOVE_START = 'mask:brush:move:start'
export const MASK_BRUSH_MOVE_END = 'mask:brush:move:end'
